import { EMAIL_REGEX, PASSWORD_REGEX } from './constant';

export const mandateValidation = {
	required: {
		value: true,
		message: 'This field is required'
	}
};

export const validation = {
	required: {
		...mandateValidation
	},
	email: {
		...mandateValidation,
		pattern: {
			value: EMAIL_REGEX,
			message: 'Invalid email address'
		}
	},
	password: {
		...mandateValidation,
		pattern: {
			value: PASSWORD_REGEX,
			message:
				'Password must contain at least 8 to 16 characters, including at least one uppercase letter, one lowercase letter,one special character and one digit.'
		}
	}
};

export const generateValidation = (fieldName: string) => {
	const mandateValidation = {
		required: {
			value: true,
			message: `${fieldName} is required`
		}
	};

	return {
		required: { ...mandateValidation },
		email: {
			...mandateValidation,
			pattern: {
				value: EMAIL_REGEX,
				message: 'Invalid email address'
			}
		},
		password: {
			...mandateValidation,
			pattern: {
				value: PASSWORD_REGEX,
				message:
					'Password must contain at least 8 to 16 characters, including at least one uppercase letter, one lowercase letter,one special character and one digit.'
			}
		}
	};
};

export const validateName =
	(fieldName: string) =>
	(value: string): string | boolean => {
		if (!value.trim()) {
			return `${fieldName} is required`;
		}
		return true; // No error
	};

export const validatePasswordConfirmation = (newPassword: string, confirmPassword: string) => {
	if (newPassword !== confirmPassword) {
		return 'Passwords do not match';
	}
	return true; // No error
};
